import EPlanCategory from '../enums/plan-category.enum'

const internalNamesByCategory: Record<EPlanCategory, string[]> = {
  [EPlanCategory.APPLICATION]: ['dedicated-app-services'],
  [EPlanCategory.BASE]: [
    'start_new',
    'unlimited_new',
    'unlimited new',
    'unlimited-new',
    'unlimited-plus-new',
  ],
  [EPlanCategory.BUILDER]: ['site-builder-plus', 'site-builder'],
  [EPlanCategory.BUSINESS]: ['business_new', 'business-plus_new'],
  [EPlanCategory.CHEAPEST]: ['parking-domains'],
  [EPlanCategory.PARKING]: ['parking-domains'],
  [EPlanCategory.PARTNER]: ['partner'],
  [EPlanCategory.WITHOUT_PLAN]: ['zero'],
  [EPlanCategory.OTHER]: ['mailForDomain', 'parking-domains'],
  [EPlanCategory.PHP]: ['unlimited-plus-new', 'business_new', 'business-plus_new'],
  [EPlanCategory.MAIL]: ['mailForDomain'],
}

export default internalNamesByCategory
